module.exports = __webpack_public_path__ + "static/33-Kaltura-350f02e991ec56a0db77116272ab61a7.png";